import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapInputMask = React.lazy(function () {
    return import('../../bootstrap-components/components/BTInputMask');
});
var handleChange = function (event, props) {
    props.onChange(event.target.value, event.target.id);
};
var bootStrapInputMask = function (props) {
    var styleName = props.hasError ? 'danger' : props.styleName;
    var newProps = __assign(__assign({}, props), { styleName: styleName, onChange: function (e) { return handleChange(e, props); } });
    return (React.createElement(BootStrapInputMask, __assign({}, newProps)));
};
export var InputMask = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapInputMask(props);
            break;
        default:
            componentToDisplay = bootStrapInputMask(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
InputMask.defaultProps = {
    styleName: 'primary',
    label: 'InputMask',
    ioTheme: themes[0],
    ioMode: 'light'
};
//# sourceMappingURL=InputMask.js.map